import { Component, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';
//import { EventEmitter } from 'stream';

@Component({
  selector: 'app-social-share',
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.css']
})
export class SocialShareComponent implements OnInit {
  urlToShare:any;
 sharedCount='1';
//  @Output()
//  emitService = new EventEmitter();
public onHide: Subject<any> = new Subject<any>();

  constructor(public bsModalRef: BsModalRef,public discussionService: DiscussionService) { }

  ngOnInit(): void {
  }

  clickedShareButton() {
    this.onHide.next(this.sharedCount);
    this.bsModalRef.hide();
  }

}
